function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M434.872,8H45.128C20.215,8.026,0.026,28.215,0,53.128v85.744C0.026,163.785,20.215,183.974,45.128,184h389.744 c24.913-0.026,45.102-20.215,45.128-45.128V53.128C479.974,28.215,459.785,8.026,434.872,8z M464,138.872 c-0.018,16.08-13.048,29.11-29.128,29.128H45.128c-16.08-0.018-29.11-13.048-29.128-29.128V53.128 C16.018,37.048,29.048,24.018,45.128,24h389.744c16.08,0.018,29.11,13.048,29.128,29.128V138.872z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M95.28,206.44c0-4.418-3.582-8-8-8s-8,3.582-8,8v34.296c0.032,11.784-4.652,23.091-13.008,31.4 c-10.63,10.152-27.362,10.152-37.992,0c-5.697-5.725-5.674-14.984,0.05-20.681c2.662-2.65,6.242-4.173,9.998-4.255 c3.992-0.056,7.839,1.498,10.672,4.312l0.656,0.648c3.192,3.055,8.256,2.943,11.311-0.25c2.984-3.119,2.956-8.042-0.063-11.126 l-0.624-0.616c-5.71-5.761-13.489-8.993-21.6-8.976H38c-16.914,0.35-30.342,14.345-29.992,31.259 c0.163,7.9,3.374,15.432,8.96,21.021c16.739,16.738,43.877,16.738,60.616,0c11.367-11.302,17.74-26.682,17.696-42.712V206.44z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M117.656,325.656c22.063-21.94,34.431-51.797,34.344-82.912V216c0-4.418-3.582-8-8-8s-8,3.582-8,8v26.744 c0.075,26.87-10.604,52.653-29.656,71.6c-3.178,3.07-3.266,8.134-0.196,11.312s8.134,3.266,11.312,0.196 C117.526,325.788,117.592,325.723,117.656,325.656z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M192,336c0,4.418,3.582,8,8,8s8-3.582,8-8v-80c0-4.418-3.582-8-8-8s-8,3.582-8,8V336z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M200,200c-4.418,0-8,3.582-8,8v16c0,4.418,3.582,8,8,8s8-3.582,8-8v-16C208,203.582,204.418,200,200,200z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M442,231.2c-8.319-0.153-16.346,3.071-22.248,8.936l-0.656,0.648c-3.193,3.054-3.304,8.118-0.25,11.311 s8.118,3.304,11.311,0.25c0.063-0.061,0.126-0.122,0.187-0.185l0.688-0.68c2.832-2.792,6.664-4.333,10.64-4.28 c8.075,0.158,14.493,6.833,14.335,14.908c-0.074,3.782-1.611,7.387-4.287,10.06c-10.63,10.152-27.362,10.152-37.992,0 c-8.356-8.309-13.04-19.616-13.008-31.4V206.44c0-4.418-3.582-8-8-8s-8,3.582-8,8v34.296c-0.048,16.027,6.319,31.407,17.68,42.712 c16.739,16.738,43.877,16.738,60.616,0c11.942-11.983,11.91-31.378-0.073-43.32C457.368,234.572,449.869,231.375,442,231.2z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M336,208c-4.418,0-8,3.582-8,8v26.744c-0.087,31.115,12.281,60.972,34.344,82.912c3.178,3.07,8.242,2.982,11.312-0.196 c2.995-3.1,2.995-8.016,0-11.116c-19.052-18.947-29.731-44.73-29.656-71.6V216C344,211.582,340.418,208,336,208L336,208z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M272,336c0,4.418,3.582,8,8,8s8-3.582,8-8v-80c0-4.418-3.582-8-8-8s-8,3.582-8,8V336z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M280,232c4.418,0,8-3.582,8-8v-16c0-4.418-3.582-8-8-8s-8,3.582-8,8v16C272,228.418,275.582,232,280,232z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M432,136H48c-4.418,0-8,3.582-8,8s3.582,8,8,8h384c4.418,0,8-3.582,8-8S436.418,136,432,136z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M432,104H48c-4.418,0-8,3.582-8,8c0,4.418,3.582,8,8,8h384c4.418,0,8-3.582,8-8C440,107.582,436.418,104,432,104z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M424,40h-32c-13.255,0-24,10.745-24,24s10.745,24,24,24h32c13.255,0,24-10.745,24-24S437.255,40,424,40L424,40z M424,72h-32 c-4.418,0-8-3.582-8-8s3.582-8,8-8h32c4.418,0,8,3.582,8,8S428.418,72,424,72z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M320,72h16c4.418,0,8-3.582,8-8s-3.582-8-8-8h-16c-4.418,0-8,3.582-8,8S315.582,72,320,72z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M272,72h16c4.418,0,8-3.582,8-8s-3.582-8-8-8h-16c-4.418,0-8,3.582-8,8S267.582,72,272,72z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M437.656,394.344c-3.124-3.123-8.188-3.123-11.312,0L412.688,408h-6.16c-2.42-6.775-7.753-12.108-14.528-14.528v-6.16 l13.656-13.656c3.07-3.178,2.982-8.242-0.196-11.312c-3.1-2.995-8.016-2.995-11.116,0L384,372.688l-10.344-10.344 c-3.178-3.07-8.242-2.982-11.312,0.196c-2.995,3.1-2.995,8.016,0,11.116L376,387.312v6.16c-6.775,2.42-12.108,7.753-14.528,14.528 h-6.16l-13.656-13.656c-3.178-3.07-8.242-2.982-11.312,0.196c-2.995,3.1-2.995,8.016,0,11.116L340.688,416l-10.344,10.344 c-3.178,3.07-3.266,8.134-0.196,11.312c3.07,3.178,8.134,3.266,11.312,0.196c0.066-0.064,0.132-0.129,0.196-0.196L355.312,424h6.16 c2.42,6.775,7.753,12.108,14.528,14.528v6.16l-13.656,13.656c-3.07,3.178-2.982,8.242,0.196,11.312c3.1,2.995,8.016,2.995,11.116,0 L384,459.312l10.344,10.344c3.178,3.07,8.242,2.982,11.312-0.196c2.995-3.1,2.995-8.016,0-11.116L392,444.688v-6.16 c6.775-2.42,12.108-7.753,14.528-14.528h6.16l13.656,13.656c3.178,3.07,8.242,2.982,11.312-0.196c2.995-3.1,2.995-8.016,0-11.116 L427.312,416l10.344-10.344C440.779,402.532,440.779,397.468,437.656,394.344L437.656,394.344z M384,424c-4.418,0-8-3.582-8-8 s3.582-8,8-8s8,3.582,8,8S388.418,424,384,424z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M121.472,408c2.42,6.775,7.753,12.108,14.528,14.528v6.16l-13.656,13.656c-3.07,3.178-2.982,8.242,0.196,11.312 c3.1,2.994,8.015,2.994,11.116,0L144,443.312l10.344,10.344c3.178,3.069,8.242,2.982,11.312-0.196c2.994-3.1,2.994-8.015,0-11.116 L152,428.688v-6.16c6.775-2.42,12.108-7.753,14.528-14.528h6.16l13.656,13.656c3.178,3.069,8.242,2.982,11.312-0.196 c2.994-3.1,2.994-8.015,0-11.116L187.312,400l10.344-10.344c3.07-3.178,2.982-8.242-0.196-11.312c-3.1-2.994-8.015-2.994-11.116,0 L172.688,392h-6.16c-2.42-6.775-7.753-12.108-14.528-14.528v-6.16l13.656-13.656c3.07-3.178,2.982-8.242-0.196-11.312 c-3.1-2.994-8.015-2.994-11.116,0L144,356.688l-10.344-10.344c-3.178-3.069-8.243-2.982-11.312,0.196 c-2.994,3.1-2.994,8.015,0,11.116L136,371.312v6.16c-6.775,2.42-12.108,7.753-14.528,14.528h-6.16l-13.656-13.656 c-3.178-3.07-8.242-2.982-11.312,0.196c-2.995,3.1-2.995,8.016,0,11.116L100.688,400l-10.344,10.344 c-3.178,3.069-3.266,8.134-0.196,11.312c3.069,3.178,8.134,3.266,11.312,0.196c0.067-0.064,0.132-0.13,0.196-0.196L115.312,408 H121.472z M144,392c4.418,0,8,3.582,8,8s-3.582,8-8,8s-8-3.582-8-8S139.582,392,144,392z"
});

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

var _ref27 = /*#__PURE__*/React.createElement("g", null);

var _ref28 = /*#__PURE__*/React.createElement("g", null);

var _ref29 = /*#__PURE__*/React.createElement("g", null);

var _ref30 = /*#__PURE__*/React.createElement("g", null);

var _ref31 = /*#__PURE__*/React.createElement("g", null);

var _ref32 = /*#__PURE__*/React.createElement("g", null);

var SvgAc = function SvgAc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1E3EE"
    },
    d: "M45.12,16h389.76C455.381,16,472,32.619,472,53.12v85.76c0,20.501-16.619,37.12-37.12,37.12H45.12 C24.619,176,8,159.381,8,138.88V53.12C8,32.619,24.619,16,45.12,16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M47.28,296c-11.374,0.028-22.287-4.491-30.312-12.552c-11.942-11.983-11.909-31.378,0.074-43.32 c5.579-5.56,13.084-8.757,20.958-8.928h0.648c8.111-0.018,15.89,3.215,21.6,8.976l0.624,0.616c3.09,3.158,3.036,8.223-0.122,11.313 c-3.085,3.019-8.008,3.047-11.126,0.063l-0.656-0.648c-2.824-2.809-6.657-4.365-10.64-4.32 c-8.075,0.158-14.493,6.833-14.335,14.908c0.074,3.782,1.611,7.387,4.287,10.06c10.63,10.152,27.362,10.152,37.992,0 c8.356-8.309,13.04-19.616,13.008-31.4V206.44c0-4.418,3.582-8,8-8s8,3.582,8,8v34.296c0.048,16.027-6.319,31.407-17.68,42.712 C69.576,291.515,58.658,296.035,47.28,296L47.28,296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M112,328c-4.418-0.001-7.999-3.583-7.998-8.002c0-2.121,0.843-4.154,2.342-5.654 c19.052-18.947,29.731-44.73,29.656-71.6V216c0-4.418,3.582-8,8-8s8,3.582,8,8v26.744c0.087,31.115-12.281,60.972-34.344,82.912 C116.156,327.156,114.122,328,112,328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M200,344c-4.418,0-8-3.582-8-8v-80c0-4.418,3.582-8,8-8s8,3.582,8,8v80 C208,340.418,204.418,344,200,344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M200,232c-4.418,0-8-3.582-8-8v-16c0-4.418,3.582-8,8-8s8,3.582,8,8v16 C208,228.418,204.418,232,200,232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M432.72,296c-11.378,0.035-22.297-4.485-30.32-12.552c-11.367-11.302-17.74-26.682-17.696-42.712 V206.44c0-4.418,3.582-8,8-8s8,3.582,8,8v34.296c-0.032,11.784,4.652,23.091,13.008,31.4c10.63,10.152,27.362,10.152,37.992,0 c5.697-5.725,5.675-14.984-0.05-20.681c-2.659-2.646-6.232-4.169-9.982-4.255c-3.976-0.053-7.808,1.488-10.64,4.28l-0.688,0.68 c-3.09,3.158-8.155,3.212-11.313,0.122s-3.212-8.155-0.122-11.313c0.061-0.063,0.124-0.124,0.187-0.185l0.656-0.648 c5.902-5.865,13.929-9.089,22.248-8.936c16.914,0.35,30.342,14.345,29.992,31.259c-0.163,7.9-3.374,15.432-8.96,21.021 C455.002,291.529,444.089,296.036,432.72,296L432.72,296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M368,328c-2.122,0-4.156-0.844-5.656-2.344c-22.063-21.94-34.431-51.797-34.344-82.912V216 c0-4.418,3.582-8,8-8s8,3.582,8,8v26.744c-0.075,26.87,10.604,52.653,29.656,71.6c3.124,3.125,3.123,8.19-0.002,11.314 C372.154,327.157,370.121,328,368,328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M280,344c-4.418,0-8-3.582-8-8v-80c0-4.418,3.582-8,8-8s8,3.582,8,8v80 C288,340.418,284.418,344,280,344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M280,232c-4.418,0-8-3.582-8-8v-16c0-4.418,3.582-8,8-8s8,3.582,8,8v16 C288,228.418,284.418,232,280,232z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D8F9F"
    },
    d: "M432,152H48c-4.418,0-8-3.582-8-8s3.582-8,8-8h384c4.418,0,8,3.582,8,8S436.418,152,432,152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D8F9F"
    },
    d: "M432,120H48c-4.418,0-8-3.582-8-8c0-4.418,3.582-8,8-8h384c4.418,0,8,3.582,8,8 C440,116.418,436.418,120,432,120z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBF41"
    },
    d: "M392,48h32c8.837,0,16,7.163,16,16l0,0c0,8.837-7.163,16-16,16h-32c-8.837,0-16-7.163-16-16l0,0 C376,55.163,383.163,48,392,48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4FB86A"
    },
    d: "M336,72h-16c-4.418,0-8-3.582-8-8s3.582-8,8-8h16c4.418,0,8,3.582,8,8S340.418,72,336,72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2BB3CE"
    },
    d: "M288,72h-16c-4.418,0-8-3.582-8-8s3.582-8,8-8h16c4.418,0,8,3.582,8,8S292.418,72,288,72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M384,440c-13.255,0-24-10.745-24-24s10.745-24,24-24s24,10.745,24,24S397.255,440,384,440z M384,408 c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S388.418,408,384,408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M400,472c-2.122,0-4.156-0.844-5.656-2.344L384,459.312l-10.344,10.344 c-3.178,3.07-8.242,2.982-11.312-0.196c-2.995-3.1-2.995-8.016,0-11.116L384,436.688l21.656,21.656 c3.124,3.125,3.123,8.19-0.002,11.314C404.154,471.157,402.121,472,400,472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M384,456c-4.418,0-8-3.582-8-8v-16c0-4.418,3.582-8,8-8s8,3.582,8,8v16 C392,452.418,388.418,456,384,456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M384,395.312l-21.656-21.656c-3.07-3.178-2.982-8.242,0.196-11.312c3.1-2.995,8.016-2.995,11.116,0 L384,372.688l10.344-10.344c3.178-3.07,8.242-2.982,11.312,0.196c2.995,3.1,2.995,8.016,0,11.116L384,395.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M384,408c-4.418,0-8-3.582-8-8v-16c0-4.418,3.582-8,8-8s8,3.582,8,8v16 C392,404.418,388.418,408,384,408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M432,440c-2.122,0-4.156-0.844-5.656-2.344L404.688,416l21.656-21.656 c3.178-3.07,8.242-2.982,11.312,0.196c2.995,3.1,2.995,8.016,0,11.116L427.312,416l10.344,10.344 c3.124,3.125,3.123,8.19-0.002,11.314C436.154,439.157,434.121,440,432,440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M416,424h-16c-4.418,0-8-3.582-8-8s3.582-8,8-8h16c4.418,0,8,3.582,8,8S420.418,424,416,424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M336,440c-4.418-0.001-7.999-3.583-7.998-8.002c0-2.121,0.843-4.154,2.342-5.654L340.688,416 l-10.344-10.344c-3.07-3.178-2.982-8.242,0.196-11.312c3.1-2.995,8.016-2.995,11.116,0L363.312,416l-21.656,21.656 C340.156,439.156,338.122,440,336,440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M368,424h-16c-4.418,0-8-3.582-8-8s3.582-8,8-8h16c4.418,0,8,3.582,8,8S372.418,424,368,424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M144,424c-13.255,0-24-10.745-24-24s10.745-24,24-24c13.255,0,24,10.745,24,24S157.255,424,144,424z  M144,392c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S148.418,392,144,392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M160,456c-2.122,0-4.156-0.844-5.656-2.344L144,443.312l-10.344,10.344 c-3.178,3.069-8.243,2.982-11.312-0.196c-2.994-3.1-2.994-8.015,0-11.116L144,420.688l21.656,21.656 c3.124,3.125,3.123,8.19-0.002,11.314C164.155,455.157,162.121,456,160,456L160,456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M144,440c-4.418,0-8-3.582-8-8v-16c0-4.418,3.582-8,8-8s8,3.582,8,8v16 C152,436.418,148.418,440,144,440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M144,379.312l-21.656-21.656c-3.07-3.178-2.982-8.242,0.196-11.312c3.1-2.994,8.015-2.994,11.116,0 L144,356.688l10.344-10.344c3.178-3.069,8.242-2.982,11.312,0.196c2.994,3.1,2.994,8.015,0,11.116L144,379.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M144,392c-4.418,0-8-3.582-8-8v-16c0-4.418,3.582-8,8-8s8,3.582,8,8v16 C152,388.418,148.418,392,144,392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M192,424c-2.122,0-4.156-0.844-5.656-2.344L164.688,400l21.656-21.656 c3.178-3.069,8.243-2.982,11.312,0.196c2.994,3.1,2.994,8.015,0,11.116L187.312,400l10.344,10.344 c3.124,3.125,3.123,8.19-0.002,11.314C196.154,423.157,194.121,424,192,424L192,424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M176,408h-16c-4.418,0-8-3.582-8-8s3.582-8,8-8h16c4.418,0,8,3.582,8,8S180.418,408,176,408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M96,424c-4.418-0.001-7.999-3.583-7.998-8.002c0-2.121,0.843-4.154,2.342-5.654L100.688,400 l-10.344-10.344c-3.07-3.178-2.982-8.242,0.196-11.312c3.1-2.995,8.016-2.995,11.116,0L123.312,400l-21.656,21.656 C100.156,423.156,98.122,424,96,424L96,424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88D0EF"
    },
    d: "M128,408h-16c-4.418,0-8-3.582-8-8s3.582-8,8-8h16c4.418,0,8,3.582,8,8S132.418,408,128,408z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ac.cbb3af89.svg";
export { ForwardRef as ReactComponent };